import type { ItemRowProps } from "./_ItemRowShared.js";
import { ItemRowDesktop } from "./ItemRowDesktop.js";
import { ItemRowMobile } from "./ItemRowMobile.js";

export type { ItemRowProps as Props };

export function ItemRow({ item, isRead, onRead, source, highlight, mobile = false }: ItemRowProps) {
  return mobile
    ? <ItemRowMobile item={item} isRead={isRead} onRead={onRead} source={source} highlight={highlight} />
    : <ItemRowDesktop item={item} isRead={isRead} onRead={onRead} source={source} highlight={highlight} />;
}
